import { z } from 'zod';
import { CLIENT_LOCATION_CONFIRMATION_SOURCES } from '@/lib/sessionLocation/types';

const US_STATE_CODES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC',
] as const;

function isValidUsZip(raw: string): boolean {
  return /^\d{5}(-\d{4})?$/.test(raw.trim());
}

export const clientLocationConfirmationFormSchema = z.object({
  // Maximums match the bots' validator (parseLocationConfirmationInput in @unify/fhir-model).
  street: z.string().trim().min(1, 'Street address is required').max(200, 'Street address is too long'),
  city: z.string().trim().min(1, 'City is required').max(100, 'City is too long'),
  state: z
    .string()
    .trim()
    .min(1, 'State is required')
    .refine((v) => (US_STATE_CODES as readonly string[]).includes(v), {
      message: 'Enter a valid US state or territory code',
    }),
  postalCode: z
    .string()
    .trim()
    .min(1, 'ZIP code is required')
    .refine(isValidUsZip, { message: 'Enter a valid ZIP code' }),
  notAtUsualAddress: z.boolean(),
  attestationAccepted: z.boolean().refine((v) => v === true, {
    message: 'You must confirm your location to join the session',
  }),
});

export type ClientLocationConfirmationFormInput = z.infer<typeof clientLocationConfirmationFormSchema>;

export const clientLocationConfirmationSourceSchema = z.enum(CLIENT_LOCATION_CONFIRMATION_SOURCES);
